/**
 * WordPress dependencies
 */
import deprecated from '@wordpress/deprecated';

/**
 * Internal dependencies
 */
import { NavigatorBackButton } from '../navigator-back-button/component';
import { contextConnect } from '../../context';
import { jsx as _jsx } from "react/jsx-runtime";
function UnconnectedNavigatorToParentButton(props, forwardedRef) {
  deprecated('wp.components.NavigatorToParentButton', {
    since: '6.7',
    alternative: 'wp.components.Navigator.BackButton'
  });
  return /*#__PURE__*/_jsx(NavigatorBackButton, {
    ref: forwardedRef,
    ...props
  });
}

/**
 * @deprecated
 */
export const NavigatorToParentButton = contextConnect(UnconnectedNavigatorToParentButton, 'Navigator.ToParentButton');